'use strict';

angular.module('licensure.services')
    .factory('IPChecklists', ['$http', '$q', '$rootScope', '$timeout', '$compile', 'FBResponses', 'Documents', 'IPComment', 'Logger', function ($http, $q, $rootScope, $timeout, $compile, FBResponses, Documents, IPComment, Logger) {

        // --- Minimal addition: small helper to wait until HTML is really rendered ---
        /* If users still experiencing, try to raise PDF_HTML_MIN_LENGTH to 2,200 ~ 2,500 MS and increase max wait PDF_MAX_WAIT_MS to 10,000 ~ 12,000 MS*/
        var PDF_HTML_MIN_LENGTH = 1800;          // Minimum HTML size before we consider it "ready". Larger = fewer partial PDFs, but longer wait when pages are legitimately small.
        var PDF_MAX_WAIT_MS = 8000;              // stop waiting after this time, so user isn't stuck forever. arger = better chance of full render on slow networks, but longer spinner if something is truly broken.
        var PDF_POLL_INTERVAL_MS = 180;          // how often to re-check. Smaller = more responsive, more digest churn. Larger = less CPU, potentially slower to notice readiness.

        function captureWhenReady(getHtmlFn, done) {
            var start = performance.now();
            (function poll() {
                var html = getHtmlFn() || '';
                if (html.length >= PDF_HTML_MIN_LENGTH || (performance.now() - start) >= PDF_MAX_WAIT_MS) {
                    done(html);
                } else {
                    $timeout(poll, PDF_POLL_INTERVAL_MS);
                }
            })();
        }

        return {
            getByID: function (id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/IPChecklists/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function () {
                        // handle error
                    });

                return d.promise;
            },

            save: function (checklist, inspection_id) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/IPChecklists/';
                if (!isUndefined(checklist.id)) {
                    method = 'PUT';
                    url += checklist.id;
                }

                FBResponses.saveByForm(checklist.response, inspection_id, null, null, true, true).then(function (processedResponse) {
                    if (processedResponse != null) {
                        checklist.response = processedResponse;

                        $http({
                            method: method,
                            url: url,
                            data: {
                                checklist: checklist,
                                inspection_id: inspection_id
                            }
                        }).then(function (response) {
                            d.resolve(response.data);
                        }).catch(function (response) {
                            Logger.logAngularApiErrors(response.data, response.status, response.config);
                            d.resolve(null);
                        });
                    }
                    else {
                        d.resolve(null);
                    }
                });

                return d.promise;
            },

            updateBatch: function (checklists) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/IPChecklists/saveBatch';

                var isUpdate = checklists.every(function (checklist) {
                    return !isUndefined(checklist.id);
                });

                if (isUpdate) {
                    method = 'PUT';
                    url = apiLocation + '/api/IPChecklists/updateBatch';
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        checklists: checklists
                    }
                }).then(function (response) {
                    d.resolve(response.data);
                }).catch(function (response) {
                    Logger.logAngularApiErrors(response.data, response.status, response.config);
                    d.resolve(null);
                });

                return d.promise;
            },

            getDocumentsAndComments: function (inspection) {
                var d = $q.defer();

                Documents.getDocumentsByInspection(inspection.id).then(function (documents) {
                    if (document != null) {
                        inspection.documents = documents;

                        IPComment.listIPCommentAsync(inspection.id).then(function (comments) {
                            if (comments != null) {
                                inspection.comments = comments;
                                d.resolve(inspection);
                            }
                            else {
                                d.resolve(null);
                            }
                        });

                    }
                    else {
                        d.resolve(null);
                    }
                });

                return d.promise;
            },

            generatingPDF: function (inspection) {
                var d = $q.defer();
                var pdfScope = $rootScope.$new(true, $rootScope);
                pdfScope.inspection = angular.copy(inspection);
                var element = $compile('<inspection-pdf inspection="inspection"></inspection-pdf>')(pdfScope);

                pdfScope.$on('$destroy', function () {
                    inspection = null;
                    if (pdfScope) {
                        pdfScope.$destroy();
                        pdfScope.inspection = null;
                        pdfScope = null;
                    }
                    if (element) {
                        angular.element(element).off();
                        angular.element(element).remove();
                        element = null;
                    }
                });

                captureWhenReady(function () { return element.html(); }, function (html) {
                    $http.post(apiLocation + '/api/IPChecklists/generatepdf', {
                        html: html,
                        checklistID: inspection.checklist.id,
                        inspectionID: inspection.id,
                        visitID: inspection.visit_id,
                        name: inspection.number,
                        outcome: inspection.outcome,
                        signatureTypeInPerson: inspection.checklist.signature_type_in_person
                    })
                        .then(function (response) {
                            pdfScope.inspection = null;
                            angular.element(element).off();
                            angular.element(element).remove();
                            pdfScope.$destroy();
                            d.resolve(response.data);
                        })
                        .catch(function () {
                            pdfScope.inspection = null;
                            angular.element(element).off();
                            angular.element(element).remove();
                            pdfScope.$destroy();
                            d.resolve(false);
                        });
                });

                return d.promise;
            },

            // The `generatePDF` method is still used by the submission of checklists in the public portal.
            generatePDF: function (inspection) {
                var d = $q.defer();

                Documents.getDocumentsByInspection(inspection.id).then(function (documents) {
                    inspection.documents = documents;

                    IPComment.listIPCommentAsync(inspection.id).then(function (comments) {
                        inspection.comments = comments;

                        var pdfScope = $rootScope.$new(true, $rootScope);
                        pdfScope.inspection = angular.copy(inspection);
                        var element = $compile('<inspection-pdf inspection="inspection"></inspection-pdf>')(pdfScope);

                        pdfScope.$on('$destroy', function () {
                            inspection = null;
                            if (pdfScope) {
                                pdfScope.$destroy();
                                pdfScope.inspection = null;
                                pdfScope = null;
                            }
                            if (element) {
                                angular.element(element).off();
                                angular.element(element).remove();
                                element = null;
                            }
                        });

                        captureWhenReady(function () { return element.html(); }, function (html) {
                            $http.post(apiLocation + '/api/IPChecklists/generatepdf', {
                                html: html,
                                checklistID: inspection.checklist.id,
                                inspectionID: inspection.id,
                                visitID: inspection.visit_id,
                                name: inspection.number,
                                outcome: inspection.outcome,
                                signatureTypeInPerson: inspection.checklist.signature_type_in_person
                            })
                                .then(function () {
                                    pdfScope.inspection = null;
                                    angular.element(element).off();
                                    angular.element(element).remove();
                                    pdfScope.$destroy();
                                    d.resolve();
                                })
                                .catch(function () {
                                    pdfScope.inspection = null;
                                    angular.element(element).off();
                                    angular.element(element).remove();
                                    pdfScope.$destroy();
                                    d.resolve();
                                });
                        });
                    });
                });

                return d.promise;
            }
        };
    }])
    ;